import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./Texts.da.resx"
import { R as _en } from "./Texts.en.resx"
import { R as _nb } from "./Texts.nb.resx"

type Translations = {
	"YouHaveBlockingConsultation": string,
	"BlockingConsultationMessage": string,
	"BlockingConsultationMessage2": string,
	"TheConsultationList": string,
	"WhoNeedsHelp": string,
	"Myself": string,
	"AddPet": string,
	"AddChildUnderCertainAge": string,
	"AddFirstChild": string,
	"Ok": string,
	"HowDoYouWantToContact": string,
	"TextConsultations": string,
	"PerConsultation": string,
	"Free": string,
	"Back": string,
	"VideoConsultations": string,
	"DisclaimerHeader": string,
	"DisclaimerButtonText": string,
	"PhoneNumberLabel": string,
	"SubjectRequired": string,
	"MessageRequired": string,
	"PhoneRequired": string,
	"InvalidPhoneNumber": string,
	"Confirm": string,
	"ConfirmAndSend": string,
	"PhoneFormDescription": string,
	"PhoneFormHeader": string,
	"NotifyOwnDoctorDescription": string,
	"NotifyOwnDoctorHeader": string,
	"Yes": string,
	"No": string,
	"DescribeProblemHeader": string,
	"SubjectLabel": string,
	"MessageLabel": string,
	"SubjectPlaceholder": string,
	"MessagePlaceholder": string,
	"ImportantInfoHeader": string,
	"Next": string,
	"BookOrQueueUpHeader": string,
	"QueueUpDescription": string,
	"WaitingTime": string,
	"QueueUpButtonText": string,
	"BookConsultation": string,
	"SelectCaregiverTitle": string,
	"SelectCaregiverDescription": string,
	"TermsOfService1": string,
	"TermsOfService2": string,
	"YouCanAlsoMessageUs1": string,
	"YouCanAlsoMessageUs2": string,
	"AttachFiles": string,
	"FileTooLargeErrorMessage": string,
	"DuplicateNameErrorMessage": string,
	"ErrorFetchingTimetable": string,
	"ErrorFetchingWaitingTime": string,
	"ErrorFetchingCaregivers": string,
	"Today": string,
	"TimeZoneWarning": string,
	"OutsideOpeningHours": string,
	"PleaseChooseDate": string,
	"InvalidPayment": string,
	"AllCaregivers": string,
	"TimeslotUnavailable": string,
	"ErrorSchedulingConsultation": string,
	"UnsupportedDeviceVideo": string,
	"NoAvailableTimeslotsHeader": string,
	"NoAvailableTimeslotsDescription": string,
	"NoTimeslotsForCaregiverOnSelectedDay": string,
	"AvailableFrom": string,
	"FileRejectionsHeader": string,
	"MaxUploadsReached": string,
	"AttachmentUploadFailed": string,
	"AttachmentsRequiredErrorMessage": string,
	"PrescriptionQuestions": string,
	"AiNurseModalHeader": string,
	"AiNurseModalDescription": string,
	"Skip": string,
	"GoToQuestion": string,
	"AiNurseQuestionsHeader": string,
	"AiNurseOverviewHeader": string,
	"AiNurseOverviewDescription": string,
	"AiNurseSubjectTag": string,
	"AiNurseUpdatedMessageTag": string,
	"AiNurseQuestionsSubheader": string,
	"AiNurseEditMessage": string,
	"AiNurseSendMessage": string,
	"AiNurseSaveAndContinue": string,
	"AiNurseAnswerPlaceholder": string,
	"InsuranceProviderInfoCardWithProviderTitle": string,
	"InsuranceProviderInfoCardWithProviderParagraph1": string,
	"InsuranceProviderInfoCardWithProviderParagraph2": string,
	"InsuranceProviderInfoCardNoProviderTitle": string,
	"InsuranceProviderInfoCardNoProviderParagraph": string,
	"InsuranceProviderInfoCardGoToProfile": string,
	"AccessVia": string,
	"Attachments": string,
	"AdultWarningBookingTitle": string,
	"AdultWarningBookingText": string,
	"GoToProfile": string,
	"OtherHouseholdmembers": string,
	"CurrentPetWeight": string,
	"PleaseEnterANumber": string,
	"KilosSuffix": string,
	"CurrentPetWeightHelperText": string,
	"CurrentPetWeightPlaceholder": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }